export default __webpack_public_path__ + "static/media/success-team.6b12ec01.jpg";